import Button from 'blocks.simple/button/button'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import translate from 'core/translate'
import { cn } from 'ethcss'
import EditText from 'molecules/EditText'
import React, { useState } from 'react'
import { colors, grid, text } from 'theme'
import styles from './files__moderation.jcss'
import { api } from 'core/api/ConnectionManager'

const MODERATION_STATUS = [
    {
        id: 0,
        value: 'pending',
        name: translate('moderationPending'),
    },
    {
        id: 1,
        value: 'approved',
        name: translate('moderationApprove'),
    },
    {
        id: 2,
        value: 'rejected',
        name: translate('moderationReject'),
    },
]

const getDefaultStatus = (selectedInfo: any) => {
    return MODERATION_STATUS.find((item) => item.value === selectedInfo?.moderation?.status)?.id
}

const getDirectoryAndFilesIds = (selectedItems: any[], selectedInfo: any) => {
    if (selectedInfo) {
        if (selectedInfo.isDirectory) {
            return [[], [selectedInfo.id]]
        } else {
            return [[selectedInfo.id], []]
        }
    } else {
        const groupIds = [...selectedItems.filter((item) => item.isDirectory)].map((item) => item.id)
        const ids = [...selectedItems.filter((item) => !item.isDirectory)].map((item) => item.id)

        return [ids, groupIds]
    }
}

const FilesModeration = ({
    selectedInfo,
    selectedItems,
    onClose,
}: {
    selectedInfo: any
    selectedItems: any[]
    onClose: () => void
}) => {
    const [status, setStatus] = useState(getDefaultStatus(selectedInfo) ?? MODERATION_STATUS[0].id)
    const [comment, setComment] = useState('')

    const onCancel = () => {
        onClose()
    }

    const onUpdate = () => {
        const newStatus = MODERATION_STATUS.find((item) => item.id === status)?.value
        if (!newStatus) return
        const [ids, groupIds] = getDirectoryAndFilesIds(selectedItems, selectedInfo)
        api.send('updateModerationStatus', {
            ids,
            groupIds,
            status: newStatus,
            comment,
        }).then((res: any) => {
            if (!res.error) {
                onClose()
            }
        })
    }

    return (
        <div className={cn(styles.wrapper, grid.centerBlock)}>
            <Dropdown
                options={MODERATION_STATUS}
                labelField="name"
                label={translate('moderationForBroadcast')}
                valueField="id"
                value={status}
                onChange={(selected: any) => {
                    setStatus(selected.id)
                }}
                className={grid.mb_md}
            />
            <EditText
                placeholder={translate('moderatorCommentPlaceholder')}
                value={comment}
                label={translate('moderatorComment')}
                type="area"
                onChange={(e: string) => setComment(e)}
            />
            <div style={{ color: colors.grey }} className={grid.mb_md}>
                {translate('moderationDescription')}
            </div>
            <div className={cn(grid.row, grid.center)}>
                <Button className={grid.mr_mdPlus} onClick={onCancel}>
                    {translate('cancel')}
                </Button>
                <Button mod={'fill'} onClick={onUpdate}>
                    {translate('save')}
                </Button>
            </div>
        </div>
    )
}

export default FilesModeration
